module.exports = __webpack_public_path__ + "static/img/home_productcard_pu.69073571.jpg";